import { FadeLoader } from "react-spinners";

export default function Spinners() {
  return (
    <div className="flex flex-1 items-center justify-center min-h-screen">
      <FadeLoader color="#22c55e" />
    </div>
  );
}
